import { render, staticRenderFns } from "./hospitalIn.vue?vue&type=template&id=2b2f0070&scoped=true"
import script from "./hospitalIn.vue?vue&type=script&lang=js"
export * from "./hospitalIn.vue?vue&type=script&lang=js"
import style0 from "./hospitalIn.vue?vue&type=style&index=0&id=2b2f0070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f0070",
  null
  
)

export default component.exports